import { useMutation } from '@tanstack/vue-query';
import { inject } from 'vue';
import { useToast } from 'vue-toastification';

import { postHubspotTicket } from '@/api/calls/hubspot/hubspot.api';
import Reporter from '@/api/clients/reporter/reporter';
import type { Translate } from '@/types/i18n/i18n.types';

export function useHubspotTicket() {
  const t = inject('t') as Translate;

  return useMutation({
    mutationFn: async (formData: FormData) => {
      return postHubspotTicket(formData);
    },
    onSuccess: (data, variables) => {
      useToast().success(t('general.support.widget.success'));

      Reporter().reportData('support_form-submit', {
        slug: variables.get('url'),
        user_uuid: variables.get('user_uuid'),
        email: variables.get('email'),
        company_uuid: variables.get('company_uuid'),
        language: variables.get('locale'),
        ticket_category: variables.get('question_type')
      });
    },
    onError: () => {
      useToast().error(t('general.error.general'));
    }
  });
}
